/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum CaseDocumentType {
  None = 0,
  Eur1 = 1,
  RegistrationCard = 2,
  Delivery = 3,
  T2L = 4,
  OtherInvoicing = 5,
  AdditionalHandling = 6,
}
